import { ProductType } from '@/shared/types/product'

import { TCartItem } from '../types/cart-item'

/**
 * Calculates the number of service in the basket current product
 * @param productId - id of product
 * @param cartItems - products from cart
 */
export const getCartServicesCountByProduct = (cartItems: TCartItem[], productId: number): number => {
	let currentItemServicesCount = 0

	cartItems.forEach(({ RELATED_PRODUCTS, TYPE_PRODUCTS }) => {
		if (TYPE_PRODUCTS === ProductType.Service && RELATED_PRODUCTS === productId) {
			currentItemServicesCount += 1
		}
	})

	return currentItemServicesCount
}
